<template>
    <div>
        <v-login
        v-if="!isAuthenticated"
        :login-error="headerSetupData.loginError"
        :facebook-login-route="headerSetupData.facebookLoginRoute"
        :google-login-route="headerSetupData.googleLoginRoute"
        :login-post-route="headerSetupData.loginPostRoute"
        :register-route="headerSetupData.registerRoute"
        :forgot-password-route="headerSetupData.forgotPasswordRoute"
        :csrf-token="headerSetupData.csrfToken"
        >
        <template v-slot:trigger>
            <!-- This will preload the image, avoiding content jumps when dialog opens -->
            <link rel="prefetch" href="/assets/images/hiska-1-new.webp" />
            <a
                @click="show = true"
                class="button button--dark relative hidden lg:flex"
            >
                <v-icon icon="filter"></v-icon>
                Dodatni filtri
            </a>
            <a
                @click="show = true"
                class="flex h-[48px] w-[80px] items-center justify-center relative rounded-full bg-black-78 text-white lg:hidden"
            >
                <v-icon icon="filter"></v-icon>
            </a>
        </template>
        </v-login>
        <v-lightbox
            foot-class="justify-between px-7"
            v-if="isAuthenticated"
            :is-authenticated="isAuthenticated"
        >
            <template v-slot:trigger>
                <a @click="show = true" class="button button--dark relative hidden lg:flex">
                    <v-icon icon="filter"></v-icon>
                    Dodatni filtri
                    <span v-if="filterCount" class="absolute -right-1 -top-[5px] bg-green text-white w-6 h-6 flex items-center justify-center rounded-full text-small-text-medium">{{ filterCount }}</span>
                </a>
                <a
                    @click="show = true"
                    class="flex h-[48px] w-[80px] items-center justify-center relative rounded-full bg-black-78 text-white lg:hidden"
                >
                    <v-icon icon="filter"></v-icon>
                    <span v-if="filterCount" class="absolute -right-1 top-0 bg-green text-white w-6 h-6 flex items-center justify-center rounded-full text-small-text-medium">{{ filterCount }}</span>
                </a>
            </template>
            <template v-slot:head>
                <v-icon icon="filter" class="mr-2.5"></v-icon>
                Dodatni filtri
            </template>
            <template v-slot:content>
                <form :action="submit_url" id="filtersForm">
                    <div class="hidden">
                        <div v-for="query in nonFilterQueryParams">
                            <input type="hidden" :name="query.name" :value="query.value"/>
                        </div>
                    </div>
                    <article class="mb-8 border-b pb-8">
                        <section
                            class="mb-6 flex items-center text-icon-text-medium text-black-78"
                        >
                            <v-icon icon="chair" class="mr-2.5"></v-icon>
                            Oprema
                        </section>
                        <section class="grid gap-4 md:grid-cols-2">
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="climate_control"
                                :checked="climate_control"
                                label="Klimatska naprava"
                            ></v-checkbox>
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="balcony"
                                :checked="balcony"
                                label="Balkon"
                            ></v-checkbox>
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="basement"
                                :checked="basement"
                                label="Klet"
                            ></v-checkbox>
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="parking"
                                :checked="parking"
                                label="Garaža ali parkirno mesto"
                            ></v-checkbox>
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="wc"
                                :checked="wc"
                                label="WC za goste"
                            ></v-checkbox>
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="kitchen"
                                :checked="kitchen"
                                label="Vgrajena kuhinja"
                            ></v-checkbox>
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="alarm"
                                :checked="alarm"
                                label="Alarmna naprava"
                            ></v-checkbox>
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="lift"
                                :checked="lift"
                                label="Dvigalo"
                            ></v-checkbox>
                        </section>
                    </article>
                    <article class="mb-8 border-b pb-8">
                        <section
                            class="mb-6 flex items-center text-icon-text-medium text-black-78"
                        >
                            <v-icon icon="floor" class="mr-2.5"></v-icon>
                            Nadstropje
                        </section>
                        <section class="grid grid-cols-2 gap-4">
                            <v-form-input
                                id="story_min"
                                label="Od"
                                type="text"
                                :value="story_min"
                                v-model="story_min"
                            ></v-form-input>
                            <v-form-input
                                id="story_max"
                                label="Do"
                                type="text"
                                :value="story_max"
                                v-model="story_max"
                            ></v-form-input>
                        </section>
                    </article>
                    <article class="mb-8 border-b pb-8">
                        <section
                            class="mb-6 flex items-center text-icon-text-medium text-black-78"
                        >
                            <v-icon icon="calendar-dot-mono" class="mr-2.5"></v-icon>
                            Leto gradnje
                        </section>
                        <section class="grid grid-cols-2 gap-4">
                            <v-form-input
                                id="year_min"
                                label="Od"
                                type="text"
                                :value="year_min"
                                v-model="year_min"
                            ></v-form-input>
                            <v-form-input
                                id="year_max"
                                label="Do"
                                type="text"
                                :value="year_max"
                                v-model="year_max"
                            ></v-form-input>
                        </section>
                    </article>
                    <!--
                    <article class="mb-8 border-b pb-8">
                        <section
                            class="mb-6 flex items-center text-icon-text-medium text-black-78"
                        >
                            <v-icon icon="loupe-box" class="mr-2.5"></v-icon>
                            Lastnosti
                        </section>
                        <section class="grid gap-4 md:grid-cols-2">
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="newly-built-property"
                                label="Nova gradnja"
                            ></v-checkbox>
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="access-disabled"
                                label="Dostop za invalide"
                            ></v-checkbox>
                        </section>
                    </article>
                    -->
                    <article class="mb-8 border-b pb-8">
                        <section
                            class="mb-6 flex items-center text-icon-text-medium text-black-78"
                        >
                            <v-icon icon="fireplace" size="3" class="mr-2.5"></v-icon>
                            Načini ogrevanja
                        </section>
                        <section class="grid gap-4 md:grid-cols-2">
                            <div v-for="heating in getHeatingTypes()">
                                <v-checkbox
                                    class="text-small-text-medium text-black-78"
                                    name="heating_types[]"
                                    :id="'heating-' + heating.value"
                                    :checked="heating.checked"
                                    :value="heating.value"
                                    :label="heating.label"
                                ></v-checkbox>
                            </div>
                        </section>
                    </article>
                    <!--
                    <article class="mb-8 border-b pb-8">
                        <section
                            class="mb-6 flex items-center text-icon-text-medium text-black-78"
                        >
                            <v-icon icon="energy" class="mr-2.5"></v-icon>
                            Energetska učinkovitost (ne dela še)
                        </section>
                    </article>
                    -->
                    <article class="mb-8 border-b pb-8">
                        <section
                            class="mb-6 flex items-center text-icon-text-medium text-black-78"
                        >
                            <v-icon icon="percent" class="mr-2.5"></v-icon>
                            Provizija
                        </section>
                        <section class="grid gap-4 md:grid-cols-2">
                            <v-checkbox
                                class="text-small-text-medium text-black-78"
                                name="provision"
                                :checked="provision"
                                label="Brez provizije"
                            ></v-checkbox>
                        </section>
                    </article>
                </form>
            </template>
            <template v-slot:foot>
                <a class="button button--gray" :href="submit_url">
                    <v-icon icon="reload"></v-icon>
                    Ponastavi
                </a>
                <button class="button" @click="submitForm" id="submitButton">
                    <v-icon icon="loupe-list"></v-icon>
                    Prikaži
                </button>
            </template>
        </v-lightbox>
    </div>
</template>

<script>
const bool_filters = [
    "climate_control",
    "basement",
    "wc",
    "kitchen",
    "alarm",
    "lift",
    "balcony",
    "parking",
    'provision',
    'heating_types[]'
]
const numeric_filters = [
    "year_min",
    "year_max",
    "story_min",
    "story_max"
]

export default {
    data() {
        return {
            nonFilterQueryParams: []
        };
    },
    props: {
        query: {
            type: Object,
            required: false,
            default: {}
        },
        headerSetupData: {
            type: Object,
            required: true,
        },
        submit_url: {
            type: String,
            required: true
        },
        heating_types: {
            type: Object,
            required: false,
            default: {}
        },
        isAuthenticated: {
            type: Boolean,
            default: false,
        },
        filterCount: {
            type: Number,
            required: true,
            default: 0,
        }
    },
    created() {
        bool_filters.forEach((filter) => this.$data[filter] = false)
        numeric_filters.forEach((filter) => this.$data[filter] = "")
    },
    mounted() {
        this.getInitialValues();
        this.prepareOldQuery();
    },
    methods: {
        submitForm() {
            document.getElementById("filtersForm").submit();
        },
        getAllFilters() {
            return bool_filters.concat(numeric_filters);
        },
        getInitialValues() {
            this.getAllFilters().forEach((filter) => {
                // Workaround as the logic does not work for array fields (heating_types)
                if (filter == 'heating_types[]') {
                    if ('heating_types' in this.query) {
                        this.setFilterValue(filter, this.query['heating_types']);
                    }
                }

                if(filter in this.query) {
                    this.setFilterValue(filter, this.query[filter])
                }
            })
        },
        prepareOldQuery() {
            let allFilters = this.getAllFilters();
            for (const [queryParam, queryValue] of Object.entries(this.query)) {
                // Workaround as the logic does not work for array fields (heating_types)
                if(!allFilters.includes(queryParam) && queryParam != 'heating_types') {
                    this.nonFilterQueryParams.push({
                        "name": queryParam,
                        "value": queryValue
                    });
                }
            }
        },
        setFilterValue(filter, value) {
            if(bool_filters.includes(filter)) {
                this.$data[filter] = Boolean(value);
                return;
            }
            if(numeric_filters.includes(filter)) {
                this.$data[filter] = value;
                return;
            }
        },
        isHeatingChecked(type) {
            if(!("heating_types" in this.query)) {
                return false;
            }

            return this.query.heating_types.includes(type);
        },
        getHeatingTypes() {
            return Object.keys(this.heating_types).map((type) => {
                return {
                    value: type,
                    label: this.heating_types[type],
                    checked: this.isHeatingChecked(type)
                }
            })
        }
    }
};
</script>
